// Send events straight to Mixpanel's EU ingestion host. The project is
// EU-resident; Mixpanel stops forwarding from the default US host in July 2026.
export const MIXPANEL_API_HOST = "https://api-eu.mixpanel.com";
